import {NgModule} from '@angular/core';
import {RestModule} from './modules/rest/rest.module';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {environment} from '@environments/environment';
import {LevelToIntensityPipe} from './pipes/level-to-intensity.pipe';
import {EnvironmentServiceProvider} from '@core/environment/environment.service.provider';
import {IntensityToLevelPipe} from '@core/pipes/intensity-to-level.pipe';
import {DurationTranslationPipe} from './pipes/duration-translation.pipe';
import {MillisToMinutesPipe} from '@core/pipes/millis-to-minutes.pipe';
import {IndicationSpecialtyTranslationPipe} from './pipes/indication-specialty-translation.pipe';
import {ChapterTranslationPipe} from './pipes/chapter-translation.pipe';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {CustomHttpInterceptor} from '@core/modules/rest/custom-http-interceptor';
import {StoreModule} from '@ngrx/store';
import {CoreReducer} from '@core/store';
import {EffectsModule} from '@ngrx/effects';
import {CoreEffects} from '@core/store/core.effects';
import {HighlighterPipe} from "@core/pipes/highlighter.pipe";

@NgModule({
    imports: [
        RestModule,
        StoreModule.forFeature(CoreReducer.REDUCER_NAME, CoreReducer.coreReducer),
        EffectsModule.forFeature([CoreEffects]),
        StoreDevtoolsModule.instrument({
            name: 'Bayer Consent NgRx',
            logOnly: environment.production
        })
    ],
    exports: [
        LevelToIntensityPipe,
        IntensityToLevelPipe,
        DurationTranslationPipe,
        IntensityToLevelPipe,
        MillisToMinutesPipe,
        IndicationSpecialtyTranslationPipe,
        ChapterTranslationPipe,
        HighlighterPipe
    ],
    declarations: [
        LevelToIntensityPipe,
        IntensityToLevelPipe,
        DurationTranslationPipe,
        IntensityToLevelPipe,
        MillisToMinutesPipe,
        IndicationSpecialtyTranslationPipe,
        ChapterTranslationPipe,
        HighlighterPipe
    ],
    providers: [
        EnvironmentServiceProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomHttpInterceptor,
            multi: true
        }
    ]
})
export class CoreModule {
}
